<template>
  <img src="/img/brand/dgvt-fuchs-signet.png" alt="DGVT Elearning">
</template>
